export default {
  camCdnUrl: 'https://embed.cdn-surfline.com',
  surflineUrl: 'https://www.surfline.com',
  appKeys: {
    segment: 'VUYKuXsQW4OXIPuGmZrK0QkY8CBJgiY1',
  },
};
